import { FC } from 'react';

import { Badge, BadgeProps } from '@mantine/core';

import { Component } from 'models';
import { ComponentHelpers } from 'helpers/ComponentHelpers';

type LaunchBadgeProps = BadgeProps & {
    component: Pick<Component, 'lifecycle'>;
};

const LaunchBadge: FC<LaunchBadgeProps> = ({ component, ...props }) => {
    const label = ComponentHelpers.getLaunchLabel(component);

    if (!label) {
        return null;
    }

    return (
        <Badge color="teal" variant="filled" size="sm" {...props}>
            {label}
        </Badge>
    );
};

export { LaunchBadge };
